export function loadCelebration2018() {
  return {
    type: 'LOAD_CELEBRATION2018',
  };
}
export function loadCelebration2018Completion(error, data) {
  return {
    type: 'LOAD_CELEBRATION2018_COMPLETION',
    error,
    data,
  };
}
